// Timings and diagnostic confidence are separate: partial evidence does not
// justify switching the statistic or including excluded captures.
export function comparableLabSummary(spread) {
  if (!spread) return null;
  const attempts = Array.isArray(spread.attempts) ? spread.attempts : [];
  const values = (attempts.length
    ? attempts.filter(a => ['ok', 'success'].includes(a.status)
      && a.measurementValid !== false && a.valid !== false
      && !a.conditionsIncomplete && !a.conditionMismatch && !a.exclusionReason).map(a => a.value)
    : spread.values || [])
    .filter(v => typeof v === 'number' && Number.isFinite(v) && (spread.metric === 'CLS' ? v >= 0 : v > 0))
    .sort((a, b) => a - b);
  if (!values.length) return null;
  const n = values.length;
  return { values, runs: n, min: values[0], max: values[n - 1],
    median: Math.round((values[Math.floor((n - 1) / 2)] + values[Math.floor(n / 2)]) / 2
      * (spread.metric === 'CLS' ? 1000 : 1)) / (spread.metric === 'CLS' ? 1000 : 1),
    above200: values.filter(v => v > 200).length };
}

export function inpRepeatedObservation(spread, language = 'cs') {
  const s = comparableLabSummary(spread);
  if (!s || s.runs < 2 || !s.above200) return '';
  return language === 'en'
    ? `Slow responsiveness occurred in ${s.above200} of ${s.runs} valid comparable lab runs (>200 ms). Values ranged from ${s.min} to ${s.max} ms; the median is ${s.median} ms. Repeated occurrence is evidenced; the specific cause is not confirmed.`
    : `Pomalá odezva se objevila ve ${s.above200} z ${s.runs} platných srovnatelných laboratorních běhů (>200 ms). Hodnoty se pohybovaly od ${s.min} do ${s.max} ms; medián je ${s.median} ms. Opakovaný výskyt je doložený, konkrétní příčina zatím potvrzená není.`;
}
